import { FiberNewRounded, RunCircleRounded,  CheckCircleRounded, DoNotDisturbRounded, CancelRounded} from '@mui/icons-material';
import { RequestStatus } from "../types/Type";

export const ChipIcon = (status: RequestStatus) => {
  if (status === 'New')
    return <FiberNewRounded />
  else if (status === 'Processing')
    return <RunCircleRounded />
  else if (status === 'Approved')
    return <CheckCircleRounded />
  else if (status === 'Denied')
    return <DoNotDisturbRounded />
  else
    return <CancelRounded />
};

export const ChipColor = (status: RequestStatus) => {
  if (status === 'New')
    return 'info';
  else if (status === 'Processing')
    return 'warning';
  else if (status === 'Approved')
    return 'success';
  else if (status === 'Denied')
    return 'error';
  else
    return 'error';
};